/**
 * Ust "sinema seridi": buyuk coinler + taranan evrenin 24s ozeti.
 *
 * Veri `/api/market/overview`dan gelir (App.tsx tek yerden ceker) - backend
 * bunu BELLEKTEKI Binance evreninden turetir, yeni istek atmaz.
 *
 * KASITLI OLARAK YOK: "toplam piyasa degeri". Binance dolasim arzi vermez;
 * tum kripto piyasasinin degeri buradan hesaplanamaz - gostermek UYDURMA
 * olurdu. Yerine gercek olan piyasa genisligi (yukselen/dusen) gosterilir.
 *
 * Kullanici (07.10): "en ust bant yavas yavas sola aksin". Icerik ekrana
 * sigmiyorsa iki kopya yan yana yazilir ve CSS ile -%50 kaydirilir (kesintisiz
 * dongu); dokununca/ustune gelince durur. Sigiyorsa akmaz (ayni coin iki kez
 * gorunmesin). Hareket azaltma tercihinde elle kaydirilir (theme.css).
 */

import { useLayoutEffect, useRef, useState, type CSSProperties } from "react";
import type { MarketOverview } from "../api/types";
import { compact, pct, price } from "../lib/format";
import { CoinAvatar } from "./Ui";

/** Bir coin genisligi (~120px) basina saniye: ~25 px/sn, okunacak kadar yavas. */
const SECONDS_PER_ITEM = 5;

export function Ticker({ overview }: { overview: MarketOverview | null }) {
  const rowRef = useRef<HTMLDivElement>(null);
  const groupRef = useRef<HTMLDivElement>(null);
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    const row = rowRef.current;
    const group = groupRef.current;
    if (!row || !group) return;
    const check = () => setOverflows(group.scrollWidth > row.clientWidth + 1);
    check();
    const observer = new ResizeObserver(check);
    observer.observe(row);
    observer.observe(group);
    return () => observer.disconnect();
  }, [overview]);

  if (!overview || overview.majors.length === 0)
    return <div className="ticker" />;

  const items = (
    <>
      {overview.majors.map((tick) => (
        <span className="ticker-item" key={tick.symbol}>
          <CoinAvatar symbol={tick.symbol} base={tick.base_asset} />
          <strong>{tick.base_asset}</strong>
          <span className="ticker-price">{price(tick.price)}</span>
          <span className={tick.change_24h_pct >= 0 ? "up" : "down"}>
            {pct(tick.change_24h_pct)}
          </span>
        </span>
      ))}
      <span className="ticker-spacer" />
      <span
        className="ticker-item ticker-stat"
        title={`Taranan ${overview.universe_size} USDT paritesinde son 24 saatte yükselen / düşen`}
      >
        <span className="ticker-label">Yükselen / Düşen:</span>
        <span className="up">{overview.advancing}</span>
        <span className="ticker-sep">/</span>
        <span className="down">{overview.declining}</span>
      </span>
      <span
        className="ticker-item ticker-stat"
        title={`Taranan ${overview.universe_size} USDT paritesinin 24 saatlik toplam işlem hacmi`}
      >
        <span className="ticker-label">24s Hacim:</span>
        <strong>${compact(overview.total_quote_volume_24h)}</strong>
      </span>
    </>
  );

  const style = {
    "--ticker-duration": `${(overview.majors.length + 2) * SECONDS_PER_ITEM}s`,
  } as CSSProperties;

  return (
    <div className="ticker" aria-label="Piyasa özeti">
      <div
        ref={rowRef}
        className="ticker-row"
        data-marquee={overflows ? "on" : undefined}
        style={style}
      >
        <div className="ticker-track">
          <div ref={groupRef} className="ticker-group">
            {items}
          </div>
          {overflows ? (
            <div className="ticker-group" aria-hidden="true">
              {items}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
